import { FCX } from '@datassential/platform-ui-lib';
import { components } from '@apiSchema';
import CircularBarWithLabel from '@components/CircularBarWithLabel/CircularBarWithLabel';
import './ConsumerRatingsMegaAttributes.scss';

type MegaAttribute = components['schemas']['ConsumerRatingsMegaAttribute'];

interface ConsumerRatingsMegaAttributesProps {
    megaAttributes: MegaAttribute[];
}

const ConsumerRatingsMegaAttributes: FCX<ConsumerRatingsMegaAttributesProps> = ({ megaAttributes }) => {
    if (!megaAttributes.length) return null;

    return (
    <div className="ConsumerRatingsMegaAttributes">
        <div className="ConsumerRatingsMegaAttributes__header">
            <span className="ConsumerRatingsMegaAttributes__section-title">Mega Attribute Ratings</span>
            <span className="ConsumerRatingsMegaAttributes__section-subtitle">
                % rating &ldquo;best in class&rdquo; or &ldquo;above average&rdquo;
            </span>
        </div>
        <div className="ConsumerRatingsMegaAttributes__columns">
            {megaAttributes.map((attr) => (
                <CircularBarWithLabel
                    key={attr.name}
                    percentage={attr.value ?? 0}
                    id={`consumer-rating-${attr.name}`}
                    title={attr.name ?? ''}
                    averageValue={attr.segmentAvgValue ?? 0}
                />
            ))}
        </div>
    </div>
    );
};

export default ConsumerRatingsMegaAttributes;
